import React, {
  createContext, useCallback, useEffect, useMemo, useState,
} from 'react';
import { v4 as uuidv4 } from 'uuid';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import PipeProviderStateSingleton from './PipeProviderState.singleton';
import Apis from '../../Apis';
import {useRootLoading} from "../RootLoading";
import { hideLoading } from 'redux/Reducers/Loading/LoadingSlice';

/* eslint-disable */
export const PipeProviderContext = createContext({});

const PipeProvider = ({ children, apiSymbols = [], loadingComponent = null, isRoot = false }) => {
  const dispatch = useDispatch()

  const { setIsLoaded } = useRootLoading()
  const [PipeName, setPipeName] = useState(null);
  const [hookPipeName, setHookPipeName] = useState(null);
  const stateSingleton = new PipeProviderStateSingleton();
  const [onReady, setOnReady] = useState(false);
  const User = useSelector(({ oidc: { user } }) => user);

  const handleCallApi = (_symbol, pipeName, callback = () => {}) => {
    stateSingleton.setExecuteApi((_symbol, finallyCallback, payload) => {
      if (Apis[_symbol]) executeHooks(_symbol, finallyCallback, payload);
    });
    stateSingleton.addCallback(pipeName || hookPipeName, callback);
    stateSingleton.addPipeIndex([_symbol], pipeName || hookPipeName);
  };

  const callApiForce = (_symbol, pipeName, callback = () => {}) => {
    const _name = uuidv4();
    handleCallApi({ ..._symbol, alias: _name }, `${pipeName}_${_name}`, callback);
  };
  const value = useMemo(() => {
    return {
      callApi: handleCallApi,
      callApiForce,
    };
  }, []);

  /* eslint-disable */
  const executeHooks = useCallback((_symbol, finallyCallback, payload = {}) => {
    Apis[_symbol](User, finallyCallback, payload);
  }, [User]);

  const handleDiableRootLoading = useCallback(() => {
    if (isRoot && setIsLoaded) {
      dispatch(hideLoading())
    }
  }, [isRoot])

  useEffect(() => {
    const name = uuidv4()
    if (!hookPipeName) {
      setHookPipeName(name)
    }
  }, [hookPipeName]);

  useEffect(() => {
    const name = uuidv4()
    if (!PipeName && apiSymbols) {
      stateSingleton.setExecuteApi((_symbol, finallyCallback, payload) => {
        if (Apis[_symbol]) executeHooks(_symbol, finallyCallback, payload);
      })

      stateSingleton.addCallback(name, () => {
        setOnReady(true);
      })
      setPipeName(name)
    }
  }, [ PipeName, apiSymbols])

  useEffect(() => {
    if (apiSymbols && apiSymbols?.length && User && Object.keys(User || {})?.length && PipeName) {
      stateSingleton.addPipeIndex(apiSymbols, PipeName);
    } else if (apiSymbols && !apiSymbols?.length && User && PipeName) {
      setOnReady(true);
    }
  }, [apiSymbols, User, PipeName]);

  useEffect(() => {
    if (isRoot) {
      stateSingleton.setCallbackRootLoading(() => {
        setTimeout(() => {
          handleDiableRootLoading();
        }, 800)
      })
    }
  }, [isRoot]);

  return (
      <PipeProviderContext.Provider value={value}>
        {(() => {
          if (onReady) {
            return children;
          }
          return loadingComponent;
        })()}
      </PipeProviderContext.Provider>
  );
};

PipeProvider.propTypes = {
  children: PropTypes.node,
  apiSymbols: PropTypes.array,
  loadingComponent: PropTypes.object,
};


export default PipeProvider;
